"use client";

import { motion } from "framer-motion";
import {
  FaIndustry,
  FaBolt,
  FaTools,
  FaShieldAlt,
  FaCogs,
  FaHeadset,
} from "react-icons/fa";

const features = [
  {
    icon: <FaIndustry />,
    title: "Industrial Expertise",
    desc: "Decades of experience in HVAC coil manufacturing and large-scale industrial projects.",
  },
  {
    icon: <FaBolt />,
    title: "Energy Efficient Systems",
    desc: "Engineered to reduce energy consumption while improving cooling performance.",
  },
  {
    icon: <FaTools />,
    title: "Precision Engineering",
    desc: "High-quality fabrication with accurate design and strict technical standards.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Trusted Quality",
    desc: "All systems undergo strict testing for durability, safety, and reliability.",
  },
  {
    icon: <FaCogs />,
    title: "Custom Solutions",
    desc: "Tailor-made HVAC systems based on project requirements and industry needs.",
  },
  {
    icon: <FaHeadset />,
    title: "Technical Support",
    desc: "Dedicated support for installation, maintenance, and troubleshooting.",
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.12 },
  },
};

const item = {
  hidden: { opacity: 0, y: 25 },
  show: { opacity: 1, y: 0 },
};

export default function WhyChooseUs() {
  return (
    <section className="relative py-24 sm:py-28 bg-slate-50 overflow-hidden text-gray-900">

      {/* 🌫️ BACKGROUND GLOWS (same style as About section) */}
      {/* <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[500px] h-[500px] bg-blue-100 rounded-full blur-3xl opacity-40" />
      <div className="absolute bottom-[-200px] right-[-100px] w-[400px] h-[400px] bg-blue-200 rounded-full blur-3xl opacity-30" />
      <div className="absolute top-1/2 left-[-120px] w-[350px] h-[350px] bg-indigo-100 rounded-full blur-3xl opacity-30" /> */}

      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 relative z-10">

        {/* Heading */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <h2 className="text-4xl sm:text-5xl font-extrabold text-blue-600">
            Why Choose AirEast HVACR
          </h2>

          <p className="text-gray-500 mt-5 text-sm sm:text-base leading-7">
            We deliver industrial-grade HVAC solutions built on engineering excellence,
            reliability, and long-term performance.
          </p>
        </motion.div>

        {/* Grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8"
        >
          {features.map((item, i) => (
            <motion.div
              key={i}
              variants={item}
              whileHover={{ y: -8, scale: 1.02 }}
              transition={{ type: "spring", stiffness: 200 }}
              className="group relative bg-white/70 backdrop-blur-md border border-gray-100 rounded-2xl p-7 shadow-sm hover:shadow-2xl overflow-hidden"
            >
              {/* glow overlay */}
              <div className="absolute inset-0 bg-blue-500 opacity-0 group-hover:opacity-5 transition duration-500" />

              {/* icon */}
              <div className="text-[#1f4ba5] text-2xl mb-4 relative z-10">
                {item.icon}
              </div>

              {/* title */}
              <h3 className="text-xl font-semibold mb-2 relative z-10">
                {item.title}
              </h3>

              {/* desc */}
              <p className="text-gray-500 text-sm leading-relaxed relative z-10">
                {item.desc}
              </p>

              {/* underline */}
              <div className="h-[2px] w-0 group-hover:w-1/2 bg-[#1f4ba5] transition-all duration-500 mt-5" />
            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
}